import React from 'react';
import propTypes from 'prop-types';

import './Day.scss';
import DaySlot from '~/Components/Pages/Calendar/WeekView/TimeGrid/DaySlot';
import moment from '~/Providers/Moment';

const Day = ({ day, events, stickerView }) => {
  return <DaySlot stickerView={stickerView} day={day} events={events[day.format('YYYY-MM-DD')]} />;
};

Day.propTypes = {
  day: propTypes.oneOfType([propTypes.object, propTypes.number]),
  events: propTypes.object,
  stickerView: propTypes.string,
};

export default Day;
